import { array, nonEmptyArray } from 'fp-ts';
import { pipe } from 'fp-ts/function';
import {
    AgeCategory,
    MultipleServiceFilterParameters,
    Service,
    ServiceResult,
    useRepositoryQuery,
    useRepositorySuspenseQuery,
} from '@mews-commander/data-access';
import { useCurrentEnterpriseId } from '@mews-commander/core';
import { keyById } from '@mews/fp';
import { isBookableService } from '../../ducks/servicesNew';

export const NO_PRODUCT_CATEGORY_INDEX = 'no-category';

const extent = {
    ageCategories: true,
    productCategories: false,
    products: false,
    bookingEngines: false,
    businessSegments: false,
    vouchers: false,
    registrationCardConfigurations: false,
};

const select = (resp: ServiceResult) => {
    const { left: additionalServices, right: bookableServices } = pipe(
        resp.services,
        array.partition(isBookableService)
    );
    return {
        ...resp,
        aggregatedData: {
            additionalServices,
            bookableServices,
            servicesById: keyById(resp.services) as Record<string, Service | undefined>,
            ageCategoriesByServiceId: pipe(
                resp.ageCategories ?? [],
                nonEmptyArray.groupBy((ageCategory) => ageCategory.serviceId)
            ) as Record<string, AgeCategory[] | undefined>,
        },
    };
};

export const useServicesQuery = (params: Partial<MultipleServiceFilterParameters> = {}) => {
    const currentEnterpriseId = useCurrentEnterpriseId();

    return useRepositoryQuery(
        'services',
        'getAll',
        {
            enterpriseIds: params.enterpriseIds ?? [currentEnterpriseId],
            extent,
            ...params,
        },
        { select }
    );
};

export const useServicesSuspenseQuery = (params: Partial<MultipleServiceFilterParameters> = {}) => {
    const currentEnterpriseId = useCurrentEnterpriseId();

    return useRepositorySuspenseQuery(
        'services',
        'getAll',
        {
            enterpriseIds: params.enterpriseIds ?? [currentEnterpriseId],
            extent,
            ...params,
        },
        { select }
    );
};
